import React from 'react';
import orderBy from 'lodash/orderBy';
import { BaseTable } from '@yme/atoms/table';
import { TABLE_COLUMNS_CONFIG, DEFAULT_LANG, NAME_KEY, SPECIFICATION_KEY, LOCALIZATION_VALUE_KEY, INDEX_PROP, ASC, KEY_PROP, TEXT_VALUE_KEY, VALUES_REMAP, } from './constants';
export function isSpecificationsEmpty(props) {
    return !props?.type;
}
const getDefaultLangOption = (option) => option[DEFAULT_LANG] ?? null;
export const getCurrentLangOption = (option, lang) => option ? option[lang] || option[DEFAULT_LANG] : null;
export function getValue({ data, key, }) {
    return data?.find((itemColumn) => itemColumn.name === key)?.value;
}
export function getOption({ data, lang, key, }) {
    const option = data.find((item) => item.name === key);
    if (!option) {
        return null;
    }
    if (typeof option.value === 'string') {
        return option.value in VALUES_REMAP ? VALUES_REMAP[option.value] : option.value;
    }
    return option.value[lang] || option.value.en || null;
}
const buildTabsContent = (data = [], lang, isComparisonTable) => {
    const result = data.reduce((acc = [], item) => {
        if (acc && item) {
            // get value for attr 'name'
            const name = getOption({
                data: item,
                lang,
                key: NAME_KEY,
            });
            // get localized Value for attr 'localizedValue'
            const value = getOption({
                data: item,
                lang,
                key: LOCALIZATION_VALUE_KEY,
            }) ||
                getOption({
                    data: item,
                    lang,
                    key: TEXT_VALUE_KEY,
                });
            // get Value for attr 'index'
            const index = getValue({
                data: item,
                key: INDEX_PROP,
            });
            const key = getValue({
                data: item,
                key: KEY_PROP,
            });
            if (typeof index !== 'number' || name === null || (value === null && !isComparisonTable)) {
                return [...acc];
            }
            return [
                ...acc,
                {
                    name,
                    value,
                    index,
                    key: typeof key === 'number' ? String(key) : key,
                },
            ];
        }
        return [...acc];
    }, []);
    return orderBy(result, [INDEX_PROP], [ASC]);
};
export const buildTabsData = ({ data = [], lang, isRightToLeft = false, isComparisonTable = false, }) => {
    const result = data.reduce((acc, item, index) => {
        if (acc && item && lang) {
            const currentTabValue = item.find((itemTab) => itemTab.name === NAME_KEY)?.value;
            const currentTabContent = item.find((itemTab) => itemTab.name === SPECIFICATION_KEY)?.value;
            const tabTitle = currentTabValue && getCurrentLangOption(currentTabValue, lang);
            const defaultTabTitle = currentTabValue && getDefaultLangOption(currentTabValue);
            const itemTabContent = (currentTabContent && buildTabsContent(currentTabContent, lang, isComparisonTable)) || [];
            if (!tabTitle || !itemTabContent.length) {
                return [...acc];
            }
            return [
                ...acc,
                {
                    entityId: index,
                    tabTitle,
                    defaultTabTitle: defaultTabTitle || tabTitle,
                    tabContent: !isComparisonTable ? (React.createElement(BaseTable, { rows: itemTabContent, columns: TABLE_COLUMNS_CONFIG, isRightToLeft: isRightToLeft })) : null,
                    rows: isComparisonTable ? itemTabContent : [],
                },
            ];
        }
        return [...acc];
    }, []);
    return result;
};
